import { render, staticRenderFns } from "./Scene.vue?vue&type=template&id=3cf8a998&scoped=true&"
import script from "./Scene.vue?vue&type=script&lang=js&"
export * from "./Scene.vue?vue&type=script&lang=js&"
import style0 from "./Scene.vue?vue&type=style&index=0&id=3cf8a998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf8a998",
  null
  
)

export default component.exports